import { Component, OnDestroy, AfterViewInit } from '@angular/core';

declare var jQuery: any;

@Component({
  selector: 'app-blank-layout',
  templateUrl: 'blankLayout.template.html',
})
export class BlankLayoutComponent implements OnDestroy, AfterViewInit {
  ngAfterViewInit() {
    jQuery('body').addClass('gray-bg');
  }

  ngOnDestroy() {
    jQuery('body').removeClass('gray-bg');
  }
}
